import cn from "classnames";
import DropdownBtn from "components/shared/dropdown";
import InlineBtn from "components/shared/inlineBtn";
import {
    bidCalculationOptionFlags,
    bidCalculationOptionFlagsEnum,
    bidStatusesEnum,
    fuelTankTypesEnum,
    syncEntityTypesEnum,
} from "helpers/enums";
import { serializeReq } from "helpers/form";
import { paths } from "helpers/paths";
import React, { Component } from "react";
import { alert } from "services/alert";
import {
    approve,
    cancelBid,
    deleteBid,
    deleteEmulatedSegment,
    disapprove,
    filterTrackerLogs,
    refreshBid,
    requestCoordinates,
    restoreBid,
    revertBid,
    sendBidsForFactoring,
} from "sources/books/bids";
import { apply } from "sources/books/calculationQueues";
import { deleteRefuelings } from "sources/books/refueling";
import CloneBid from "./cloneBid";
import RouteDetails from "./routeDetails";

export default class BidActions extends Component {
    get inlineActions() {
        const { bidPolicy, history, id, organization } = this.props;
        return [
            {
                value: "В работу",
                cname: "checkmark",
                action: () => history.push(`${paths.bidEdit(id)}?editRoute=true&confirmRoute=true`),
                show: bidPolicy.canSeeHeadToWorkBtn({ usesBidsApproval: organization.usesBidsApproval }),
            },
            {
                value: "Редактировать",
                cname: "edit",
                action: () => history.push(paths.bidEdit(id)),
                show: bidPolicy.canSeeEditBtn(),
            },
            {
                value: "Вернуть в черновик",
                cname: "undo",
                action: this.revertBid,
                show: bidPolicy.canSeeRevertBtn(),
            },
            {
                value: "Маршрут",
                cname: "edit",
                action: () => history.push(`${paths.bidEdit(id)}?editRoute=true`),
                show: bidPolicy.canSeeEditBtn() && !bidPolicy.inFinishedStatus(),
            },
            {
                value: "Восстановить",
                cname: "undo",
                action: this.restore,
                show: bidPolicy.canSeeRestoreBtn(),
            },
        ];
    }

    get dropDownActions() {
        const {
            bidPolicy,
            history,
            organization,
            refuelingServiceType,
            refuelingSettings,
            bid: { isDeleted, status },
        } = this.props;
        return [
            {
                text: "Вернуть в черновик",
                action: this.revertBid,
                show: bidPolicy.canSeeRevertBtnWhenActive(),
            },
            {
                text: "Отменить",
                action: this.cancel,
                show: bidPolicy.canSeeCancelBtn(),
            },
            {
                text: "Перерасчет",
                action: this.recalculate,
                show: bidPolicy.canSeeRecalculationBtn(),
            },
            {
                text: status === bidStatusesEnum.Done ? "Скорректировать пробег" : "Завершить заявку вручную",
                action: this.forceComplete,
                show: bidPolicy.canSeeForceCompleteBtn(),
            },
            {
                text: "Удалить",
                action: this.remove,
                show: bidPolicy.canSeeDeleteBtn(),
            },
            {
                text: "Добавить причину перепробега",
                action: this.excessMileage,
                show: bidPolicy.canSeeCriticalMileageBtn(),
            },
            {
                text: "Создать копию заявки",
                action: () => {
                    const { modal, id } = this.props;
                    return modal({
                        name: "default",
                        title: "Выберите условия копирования",
                        CustomBody: CloneBid,
                        bodyData: { bidId: id, setLoading: this.props.setLoading, history },
                    });
                },
                show: !isDeleted && !organization.distributedBidRequired,
            },
            {
                text: "Обновить синхронизацию",
                action: () => {
                    const { modal, id } = this.props;
                    return modal({
                        name: "confirm",
                        title: "Обновить синхронизацию",
                        text: "Вы уверены, что хотите актуализировать время последнего обновления заявки?",
                        buttons: { confirm: "Да", cancel: "Нет" },
                        action: () => {
                            this.props.setLoading(true);
                            refreshBid({ id })
                                .then((_) => {
                                    this.props.setLoading(false);
                                })
                                .catch(() => {
                                    this.props.setLoading(false);
                                });
                        },
                    });
                },
                show: !isDeleted,
            },
            {
                text: "Согласовать",
                action: () => !bidPolicy.disabledApproveBtn() && this.approve(),
                disabled: bidPolicy.disabledApproveBtn(),
                tooltipText:
                    "Черновик нельзя согласовать, пока заявка не синхронизирована с 1С. Пожалуйста, обновите страницу",
                show: bidPolicy.canSeeApproveBtn({ usesBidsApproval: organization.usesBidsApproval }),
            },
            {
                text: "Отменить согласование",
                action: this.disapprove,
                show: bidPolicy.canSeeDisapproveBtn({ usesBidsApproval: organization.usesBidsApproval }),
            },
            {
                text: "Сохранить шаблон маршрута",
                action: this.saveAsTemplate,
                show: bidPolicy.canSaveAsTemplate(),
            },
            {
                text: "Запланировать заправки",
                action: this.planRefueling,
                show:
                    bidPolicy.canPlanRefuelings({ refuelingServiceType, refuelingSettings }) &&
                    status !== bidStatusesEnum.Planned &&
                    status !== bidStatusesEnum.Canceled,
            },
            {
                text: "Удалить заправки",
                action: () => {
                    const { modal, id, getItem, setLoading } = this.props;
                    return modal({
                        name: "confirm",
                        title: "Удалить заправки",
                        text: "Вы уверены, что хотите удалить заправки?",
                        buttons: { confirm: "Да", cancel: "Нет" },
                        action: () => {
                            setLoading(true);
                            deleteRefuelings({ bidId: id })
                                .then(() => {
                                    getItem();
                                    setLoading(false);
                                })
                                .catch(() => setLoading(false));
                        },
                    });
                },
                show: bidPolicy.canSeeUpdateRefuelingBtn(),
            },
            {
                text: "Добавить статус синхронизации",
                action: () => {
                    const { modal, id, getItem, bid } = this.props;
                    return modal({
                        name: "addSyncStatus",
                        title: "Добавление статуса синхронизации",
                        windowMod: "wide",
                        data: {
                            entityId: id,
                            externalId: bid.externalId,
                            entityType: syncEntityTypesEnum.Bid,
                        },
                        callback: (data) => data && getItem(),
                    });
                },
                show: bidPolicy.canSeeAddSyncStatusBtn(),
            },
            {
                text: "Информация о нагрузке на ось",
                action: () => {
                    const { modal, bid } = this.props;
                    return modal({
                        name: "axisLoadValues",
                        title: "Информация о нагрузке на ось",
                        windowMod: "wide",
                        bid,
                        trackerId: bid.car ? bid.car.trackerId : null,
                    });
                },
                show: bidPolicy.canSeeAxisLoadValues(),
            },
            {
                text: "Ответы водителя",
                action: () => {
                    const { modal, bid } = this.props;
                    return modal({
                        name: "scenarioAnswers",
                        title: "Ответы водителя",
                        windowMod: "wide",
                        bid,
                    });
                },
                show: bidPolicy.canSeeScenarioAnswers(),
            },
            {
                text: "Ответы по опросам в рейсе",
                action: () => {
                    const { modal, bid } = this.props;
                    return modal({
                        name: "tripScenarioAnswers",
                        title: "Ответы по опросам в рейсе",
                        windowMod: "wide",
                        bid,
                    });
                },
                show: bidPolicy.canSeeTripScenarios(),
            },
            {
                text: "Перецепки / пересменки",
                action: () => {
                    const { modal, bid, route, bidLastCarLocation, organization, itemChangesHistory } = this.props;
                    const { autoEnteredAt, enteredAt, enteredAtByLogist } = bid.bidPoints[0];
                    return modal({
                        name: "bidItemChanges",
                        title: "Перецепки и пересменки по заявке",
                        windowMod: "wide",
                        bid,
                        route,
                        bidLastCarLocation,
                        itemChangesHistory,
                        organization,
                        getItem: this.props.getItem,
                        firstBidPointEntered: !!(autoEnteredAt || enteredAt || enteredAtByLogist),
                    });
                },
                show: bidPolicy.canSeeBidItemChanges(),
            },
            {
                text: "Факторинг заявки",
                action: () => {
                    const { modal, bid, getItem } = this.props;
                    const { id } = bid;
                    return modal({
                        name: "confirm",
                        title: "Факторинг заявки",
                        text: "Отправить заявку на факторинг?",
                        action: () => sendBidsForFactoring([id]),
                        onSuccessAction: () => getItem(),
                        buttons: { confirm: "Да", cancel: "Нет" },
                    });
                },
                show: bidPolicy.canSeeFactoring(),
            },
            {
                text: "Фильтрация трекер логов",
                action: () => {
                    const { modal, bid } = this.props;
                    const { id } = bid;
                    return modal({
                        name: "confirm",
                        title: "Фильтрация трекер логов",
                        text: "Запустить процесс анализа координат заявки?",
                        action: () => filterTrackerLogs({ bidId: id }),
                        onSuccessAction: (res) =>
                            res && alert({ message: "Анализ трекер логов успешно запущен", type: "success" }),
                        buttons: { confirm: "Да", cancel: "Нет" },
                    });
                },
                show: bidPolicy.canSeeFilterTrackerLogs(),
            },
            {
                text: "Перезапросить координаты машины за период заявки",
                action: () => {
                    const { modal, bid } = this.props;
                    const { id } = bid;
                    return modal({
                        name: "confirm",
                        title: "Коордианты машины",
                        text: "Перезапросить координаты машины за период заявки?",
                        action: () => requestCoordinates(id),
                        onSuccessAction: (res) =>
                            res && alert({ message: "Запрос координат успешно запущен", type: "success" }),
                        buttons: { confirm: "Да", cancel: "Нет" },
                    });
                },
                show: bidPolicy.canSeeRequestCoordinates(),
            },
            {
                text: "Детали маршрута",
                action: () => {
                    const { modal, route } = this.props;
                    return modal({
                        name: "default",
                        title: "Детали маршрута",
                        windowMod: "wide",
                        CustomBody: RouteDetails,
                        bodyData: { route },
                    });
                },
                show: bidPolicy.canSeeTollSegmentInfo(),
            },
            {
                text: "Удалить эмулированные сегменты",
                action: () => {
                    const { modal, bid } = this.props;
                    const { id } = bid;
                    return modal({
                        name: "confirm",
                        title: "Удаление сегментов",
                        text: "Вы уверены, что хотите удалить все эмулированные сегменты?",
                        buttons: { confirm: "Да", cancel: "Нет" },
                        action: () => {
                            const { getItem, emulatedSegments, mergeMapData, bid } = this.props;
                            mergeMapData({ isLoading: true, compareBidId: String(bid.id) });
                            const sendReq = (i) => {
                                deleteEmulatedSegment({ id: emulatedSegments[i].id, bidId: id }).then(() => {
                                    if (emulatedSegments[i + 1]) {
                                        setTimeout(() => {
                                            sendReq(i + 1);
                                        }, 1000);
                                    } else {
                                        getItem();
                                    }
                                });
                            };
                            setTimeout(() => {
                                sendReq(0);
                            }, 1000);
                        },
                    });
                },
                show: bidPolicy.canSeeRemoveEmulatedSegments(),
            },
        ];
    }

    revertBid = () => {
        const { id, modal, getItem } = this.props;
        return modal({
            name: "confirm",
            title: "Изменение заявки",
            text: `Вы уверены, что хотите вернуть заявку в статус "Черновик"?`,
            buttons: { confirm: "Да", cancel: "Нет" },
            onSuccessAction: () => this.props.history.push(paths.bidShow("bid", id)),
            action: () => revertBid({ bidId: id }).then(() => getItem()),
        });
    };

    planRefueling = () => {
        const { modal, id, bid, route, refueling } = this.props;
        const minimumVolumeInFinishDesired = refueling?.fuelTanks?.find(
            (item) => item.type === fuelTankTypesEnum.Diesel,
        )?.minimumVolumeInFinishDesired;
        return modal({
            name: "planRefueling",
            title: "Планирование заправок",
            bidId: id,
            minimumVolumeInFinishDesired,
            bid,
            route,
            refueling,
        });
    };

    saveAsTemplate = () => {
        const { modal, id } = this.props;
        return modal({
            name: "routeTemplateForm",
            title: "Создание шаблона маршрута",
            windowMod: "print",
            bidId: id,
        });
    };

    cancel = () => {
        const { modal, id, back, mergeParams } = this.props;
        return modal({
            name: "confirm",
            title: "Отмена заявки",
            text: "Вы уверены, что хотите отменить заявку?",
            onSuccessAction: () => back(),
            action: () => cancelBid({ bidId: id }).then(() => mergeParams({})),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    remove = () => {
        const { modal, id, back, mergeParams } = this.props;
        return modal({
            name: "confirm",
            title: "Удаление заявки",
            text: "Вы уверены, что хотите удалить заявку?",
            onSuccessAction: () => back(),
            buttons: { confirm: "Удалить", cancel: "Отменить" },
            action: () => deleteBid({ bidId: id }).then(() => mergeParams({})),
        });
    };

    approve = () => {
        const { modal, id, getItem } = this.props;
        return modal({
            name: "confirm",
            title: "Согласование заявки",
            text: "Вы уверены, что хотите согласовать заявку?",
            buttons: { confirm: "Согласовать", cancel: "Отменить" },
            action: () => approve({ id }).then(() => getItem()),
        });
    };

    disapprove = () => {
        const { modal, id, getItem } = this.props;
        return modal({
            name: "confirm",
            title: "Отмена согласования заявки",
            text: "Вы уверены, что хотите отменить согласование заявки?",
            buttons: { confirm: "Отменить согласование", cancel: "Закрыть" },
            action: () => disapprove({ id }).then(() => getItem()),
        });
    };

    recalculate = () => {
        const { modal, id, mergeParams, getItem } = this.props;
        return modal({
            name: "confirm",
            title: "Перерасчет заявки",
            text: "Вы уверены, что хотите пересчитать заявку?",
            buttons: { confirm: "Пересчитать", cancel: "Отменить" },
            action: () => {
                const flags = bidCalculationOptionFlags.find(
                    (item) => item.value === bidCalculationOptionFlagsEnum.None,
                ).intValue;
                apply(serializeReq({ bids: [{ id, flags }] }))
                    .then((res) => {
                        if (res && res.failedBidIds && res.failedBidIds.length > 0) {
                            alert({ message: "Не получилось пересчитать заявку", type: "warning" });
                        }
                    })
                    .then(() => getItem())
                    .then(() => mergeParams({}));
            },
        });
    };

    forceComplete = () => {
        const { modal, mergeParams, bid, getItem, pointsOrderedByRoute } = this.props;
        return modal({
            name: "forceComplete",
            title: "Завершение заявки",
            bid,
            pointsOrderedByRoute,
            windowMod: "wide",
            callback: () => {
                getItem().then(() => mergeParams({}));
            },
        });
    };

    excessMileage = () => {
        const { modal, mergeParams, id, getItem, organization, activeKms, planKms } = this.props;
        return modal({
            name: "excessMileage",
            title: "Информация о перепробеге",
            windowMod: "sm",
            bidId: id,
            activeKms,
            planKms,
            criticalMileage: organization.criticalMileage,
            callback: () => {
                getItem();
                mergeParams({});
            },
        });
    };

    restore = () => {
        const { modal, id, back, mergeParams } = this.props;
        return modal({
            name: "confirm",
            title: "Восстановление заявки",
            text: "Вы уверены, что хотите восстановить заявку?",
            onSuccessAction: () => back(),
            action: () => restoreBid({ id }).then(() => mergeParams({})),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    render() {
        const { bidPolicy } = this.props;
        if (bidPolicy.isTruckingOrganizationDispatcher()) {
            return [];
        }
        const cname = cn({ "show-bid__actions": true, "show-bid__actions--no-border": !bidPolicy.isOpened() });
        return (
            <div className={cname}>
                {this.inlineActions
                    .filter((x) => x.show)
                    .map((item, i) => (
                        <InlineBtn key={i} {...item} />
                    ))}
                {this.dropDownActions.find((x) => x.show) && (
                    <DropdownBtn text="Еще" items={this.dropDownActions.filter((x) => x.show)} />
                )}
            </div>
        );
    }
}
